module.exports = __webpack_public_path__ + "img/callnumber-poster-preview-general.ec0b6218.png";